import ScheduleIndexVue from "@/views/housekeeping/schedule/ScheduleIndex.vue";

const schedule = [
  {
    path: "/schedule",
    name: "schedule",
    component: ScheduleIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","receptionist","supervisor","housekeeping"],
      public: false,
    },
  },
];

export default schedule;
